import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-09-10T00:00:00-0400.
 */
export function useInspectionHideTemplateEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.InspectionHideTemplate, false);

  return Boolean(isEnabled);
}
